#import "./forecast/fragments.graphql"
#import "./requisition/fragments.graphql"

# Caller's inbox. Page on the server. Kind chips send filter.category;
# the Via dropdown sends filter.routeIds; the team picker and the My teams
# chip send filter.teamIds. The server expands each team to its descendants.
# Load once, refetch after a write.
# routes feeds the routed-to line and the route dropdown.
# Badge path (limit 0) returns routes: [].
# All-routes count is the same document with routeIds omitted (limit 0).
# Add a kind: spread its list fragment from InboxListItemFields.
query inbox($filter: InboxFilter, $paging: InboxPaging) {
  inbox(filter: $filter, paging: $paging) {
    total
    counts {
      category
      count
    }
    routes {
      id
      kind
      label
      count
    }
    items {
      # Repeat interface fields: Jest's Apollo mock cache does not apply
      # InboxItem fragments onto the concrete item types.
      id
      kind
      owedAs
      since
      slaHours
      overdue
      ...InboxListItemFields
      ...RequisitionApprovalInboxListFields
      ...RequisitionExceptionReasonInboxListFields
      ...ForecastSubmissionInboxListFields
    }
  }
}
